export default __webpack_public_path__ + "static/media/logo_sihapei_qr.0404d880.png";